<!--
 * @Description:
 * @Version: 2.0
 * @Autor: ShiChangZhan
 * @Date: 2021-08-27 12:41:37
 * @LastEditors: ShiChangZhan
 * @LastEditTime: 2021-09-08 10:00:12
-->
<template>
  <div id="lbWallct">
    <transition :name="transitionName">
      <router-view class="child-view"></router-view>
    </transition>
    <tFooter ref="footer"></tFooter>
  </div>
</template>


<script>
import Vue from "vue";
import $ from "jquery";
import tFooter from "../components/tfooter.vue";


export default {
  name: "index",
  data() {
    return {
      transitionName: "slide-left",
      pubShow: false,
      footerHeight: 0, // 默认footer高度
      // scrollerHeight: "100%",
    };
  },
  components: {
    tFooter,
  },
  computed: {
    bmTab() {
      let bmTab = this.$store.state.bmTab;
      if (bmTab == 3) {
        $("body").css("overflow", "hidden");
      } else {
        $("body").css("overflow", "visible");
      }
      //console.log('bmTab', bmTab);
      return bmTab;
    },
  },
  methods: {

  },
  beforeRouteUpdate(to, from, next) {
    let isBack = this.$router.isBack;
    // console.log(isBack,this.transitionName);
    if (isBack) {
      this.transitionName = "slide-right";
    } else {
      this.transitionName = "slide-left";
    }
    this.$router.isBack = false;
    next();
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
};
</script>

<style lang="scss">
#lbWallct {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  // padding-top: 52px;
  .child-view {
    position: absolute;
    width: 100%;
    transition: all 0.2s cubic-bezier(0.55, 0, 0.1, 1);
    // height: 100%;
  }
  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;


  }
  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
  }

}

.child-view {
  position: absolute;
  width: 100%;
  transition: all 0.2s cubic-bezier(0.55, 0, 0.1, 1);
  /* 动态高度，由 JavaScript 计算 */
}

.tfooter {
  /* 默认高度为104px，动态更新时，height 会被实时调整 */
  transition: height 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue